class CartLimits extends HTMLElement {
  constructor() {
    super();
    this.maxPerVariant = parseInt(this.getAttribute("data-max-variants"));
    this.maxTotalPrice = parseInt(this.getAttribute("data-max-total-price")) * 100;
    this.productExceptions = this.getAttribute("data-product-exceptions").split(",");
    this.cartItems = document.querySelector("cart-drawer-items");
    this.cartCheckoutBtn = document.querySelector("#CartDrawer-Checkout");

    this.init();
  }

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      this.validateCart();
    });
  }

  init() {
    this.validateCart();
  }

  getCart(callback) {
    fetch(`${routes.cart_url}.js`)
      .then((response) => {
        return response.json();
      })
      .then((cart) => {
        callback(cart);
      });
  }

  updateCart(body, callback) {
    fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.json())
      .then((cart) => callback(cart));
  }

  countItemsQuantity(cartItems) {
    return cartItems.filter((item, index) => {
      if (this.productExceptions.includes(item.sku)) return false;
      item.line = index + 1;
      return item.quantity > this.maxPerVariant;
    });
  }

  validateCart() {
    this.getCart((cart) => {
      // count max per variant items
      let itemsToChangeQuantity = this.countItemsQuantity(cart.items);
      let total_price = 0;
      cart.items.forEach((item) => {
        if (this.productExceptions.includes(item.sku)) return;
        total_price += item.price * item.quantity;
      });

      // validation cascate
      if (itemsToChangeQuantity.length > 0) {
        this.changeItemsQuantity(itemsToChangeQuantity);
      } else if (total_price > this.maxTotalPrice) {
        this.changeTotalPrice(cart);
      }
    });
  }

  changeTotalPrice(cart) {
    let totalPrice = 0;
    cart.items.forEach((item) => {
      if (this.productExceptions.includes(item.sku)) return;
      totalPrice += item.price * item.quantity;
    });

    const cartItems = cart.items;
    const updates = {};

    for (let i = 0; i < cartItems.length; i++) {
      if (cartItems[i].quantity > 1 && cartItems[i].sku != this.productExceptions) {
        updates[cartItems[i].variant_id] = 1;

        const removedItems = cartItems[i].quantity - 1;
        const removedPrice = removedItems * cartItems[i].price;
        totalPrice -= removedPrice;

        if (totalPrice <= this.maxTotalPrice) break;
      }
    }

    const body = JSON.stringify({
      updates,
      sections: this.cartItems.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    this.updateCart(body, (cart) => {
      this.updateQuantitySelectors(cart.items);
    });
  }

  changeItemsQuantity(items) {
    if (items.length == 0) return;

    const updates = {};

    items.forEach((item) => {
      updates[item.variant_id] = this.maxPerVariant;
    });

    const body = JSON.stringify({
      updates,
      sections: this.cartItems.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    this.updateCart(body, (cart) => {
      this.updateQuantitySelectors(cart.items);
    });
  }

  updateQuantitySelectors(items) {
    items.forEach((item) => {
      const quantitySelector = document.querySelector(
        `input[name="updates[]"][data-quantity-variant-id="${item.variant_id}"]`,
      );
      quantitySelector.setAttribute("value", item.quantity);
      quantitySelector.setAttribute("data-cart-quantity", item.quantity);
      quantitySelector.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }
}

customElements.define("cart-limits", CartLimits);
